import {defineAsyncComponent} from 'vue';

const UserManagerDetailPopup = defineAsyncComponent(() =>
  import('@/views/system/users/popup/UserManagerDetailPopup.vue'),
);
const RoleManagerDetailPopup = defineAsyncComponent(() =>
  import('@/views/system/roles/popup/RoleManagerDetailPopup.vue'),
);
const PermissionDetailPopup = defineAsyncComponent(() =>
  import('@/views/system/roles/popup/PermissionDetailPopup.vue'),
);
const UserHandOverPopup = defineAsyncComponent(() =>
  import('@/views/system/users/popup/UserHandOverPopup.vue')
);


export function settingRegister(app) {
  app.component('UserManagerDetailPopup', UserManagerDetailPopup);
  app.component('UserHandOverPopup', UserHandOverPopup);
  app.component('RoleManagerDetailPopup', RoleManagerDetailPopup);
  app.component('PermissionDetailPopup', PermissionDetailPopup);
}
